import { debug } from 'application/Shared/Utils';
import {
    formatDistanceToNow as dateFnsFormatDistanceToNow,
    isValid
} from 'date-fns';

/**
 * Converts a Date object to an ISO formatted date and time string
 * @param date - The Date object to convert
 * @returns The date as an ISO string (e.g. "2023-01-26T19:02:07.174Z"), or null if invalid
 */
export const dateTimeString = (date: Date) => {
    let transformedDate = null;

    // Add try/catch to prevent errors with invalid dates
    try {
        if (isValid(date)) {
            transformedDate = date.toISOString();
        }
    } catch (e) {
        debug.w('dateTimeString: Invalid date', e);
    }
    return transformedDate;
};

/**
 * Formats a date to show the relative time distance from now (e.g. "2 days ago")
 * @param date - The date to format, can be a Date object, timestamp number, or date string
 * @returns The formatted relative time string, or null if the date is invalid
 */
export const formatDistanceToNow = (date: number | string | Date) => {
    let transformedDate = null;

    // Add try/catch to prevent errors with invalid dates
    try {
        const parsedDate = new Date(date);
        if (isValid(parsedDate)) {
            transformedDate = dateFnsFormatDistanceToNow(parsedDate, {
                addSuffix: true
            });
        }
    } catch (e) {
        debug.w('formatDistanceToNow: Invalid date', e);
    }
    return transformedDate;
};
